<template>
    <div class="content">
      <h1>Lets Be Friends</h1>
      <p>Placeholder.</p>
    </div>

</template>


